(function(){
  document.querySelectorAll('[data-ca-copy]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var code=btn.getAttribute('data-ca-copy'),label=btn.textContent;
      var done=function(){btn.textContent=btn.getAttribute('data-copied');btn.classList.add('is-copied');setTimeout(function(){btn.textContent=label;btn.classList.remove('is-copied');},2000);};
      if(navigator.clipboard){navigator.clipboard.writeText(code).then(done,done);}else{done();}
    });
  });
  document.querySelectorAll('[data-ca-countdown]').forEach(function(el){
    var end=new Date(el.getAttribute('data-ca-countdown')).getTime();
    var pad=function(n){return String(n).padStart(2,'0');};
    var tick=function(){
      var diff=Math.max(0,end-Date.now());
      if(diff===0){el.hidden=true;return;}
      var s=Math.floor(diff/1000);
      el.querySelector('[data-d]').textContent=Math.floor(s/86400);
      el.querySelector('[data-h]').textContent=pad(Math.floor(s%86400/3600));
      el.querySelector('[data-m]').textContent=pad(Math.floor(s%3600/60));
      el.querySelector('[data-s]').textContent=pad(s%60);
    };
    tick();setInterval(tick,1000);
  });
  var bar=document.querySelector('[data-ca-sticky]'),form=document.querySelector('[data-product-form]');
  if(bar&&form&&'IntersectionObserver' in window){
    bar.hidden=false;
    new IntersectionObserver(function(e){bar.classList.toggle('is-visible',!e[0].isIntersecting&&e[0].boundingClientRect.top<0);}).observe(form);
    bar.querySelector('[data-ca-sticky-btn]').addEventListener('click',function(){form.scrollIntoView({behavior:'smooth',block:'center'});});
  }
})();
